import React, { useContext } from 'react';
import HmiContext from '../../context/HmiContext';
import ExpansionPanel from '../ExpansionPanel/ExpansionPanel';
import HmiPermissions from './HmiPermissions';
import FormatMessage from '../../messages/FormatMessage';

const HmiReadAndWrite: React.FC = () => {
  const hmiContext = useContext(HmiContext);
  const { parentApp, dependencyApps } = hmiContext.hmi;

  if (!parentApp) {
    return null;
  }

  if (parentApp.permissions) {
    return (
      <div className={'hmi-read-write'}>
        <div className={'hmi-section-title'}>
          <FormatMessage
            id={'hmi.readWrite.appAbleTo'}
            values={{ name: parentApp.info.name }}
          />
        </div>

        <ExpansionPanel
          title={
            parentApp.kind.kind === 'App'
              ? 'hmi.readAndWrite'
              : 'hmi.writeAccess'
          }
        >
          <div className={'hmi-card-subtitle hmi-card-content'}>
            {dependencyApps &&
              dependencyApps.map((depApp, index) => {
                return (
                  <HmiPermissions
                    appName={depApp.info.name}
                    key={depApp.id + index}
                    permissions={depApp.permissions}
                  />
                );
              })}
            <HmiPermissions
              appName={parentApp.info.name}
              permissions={parentApp.permissions}
            />
          </div>
        </ExpansionPanel>
      </div>
    );
  } else {
    return null;
  }
};

export default HmiReadAndWrite;
